/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 30/04/2025 - 11:05:42
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 30/04/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useState, useEffect } from "react";
import TiltedPvAreaPage from "./PVAreas/TiltedPvAreaPage";
import VerticalPvAreaPage from "./PVAreas/VerticalPvAreaPage";
import DetectionPvAreaPage from "./PVAreas/DetectionPvAreaPage";
import { db } from "../../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { selectedArea } from "../../../store/reducers/bmapSlice";
import { RootState } from "../../../store";
import CalculateGlare from "./CalculateGlare";
import images from "../../../images/index";
import { Image } from "react-bootstrap";
import { useTranslation } from 'react-i18next';


const MapPageSidebar: React.FC = () => {
  const [projectInformation, setProjectInformation] = useState<any>({});
  const selectedAreaType = useSelector(
    (state: RootState) => state.bmap.selectedArea
  );
  const dispatch = useDispatch();
  const { projectId } = useParams<{ projectId: string | any }>();
  const { t } = useTranslation(['mapPage', 'common']);
  
  const onTabChange = (areaType: string) => {
    dispatch(selectedArea({ value: areaType }));
  };
  
  // --------------fetch project name-----
  useEffect(() => {
    const getDocument = async () => {

      if (!projectId) {
        console.error("No project ID available");
        return;
      }

      const docRef = doc(db, "projects", projectId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setProjectInformation(docSnap.data());
        localStorage.setItem("projectName", docSnap.data().projectName);
        localStorage.setItem("utcRegion", docSnap.data().timeZone);
      } else {
        // console.log("No such document!");
      }
    };
    if (projectId) {
      getDocument();
    }
  }, [projectId]);
  
  return (
    <section
      className="d-flex justify-content-between pb-2 align-items-center flex-column"
      style={{ width: "100%", height: "89vh" }}
    >
      <div>
        <div className="side_bar_div">
          <p
            onClick={() => {
              onTabChange("tiltedTab");
            }}
            className={
              selectedAreaType?.value === "tilted" || selectedAreaType?.value === "tiltedTab"
                ? "activeType"
                : "nonActiveType"
            }
          >
            {(selectedAreaType?.value === "tilted" || selectedAreaType?.value === "tiltedTab") && 
              <span className="active-indicator"></span>
            }
            {t('mapPage:sidebar.tabs.tiltedPVAreas')}
          </p>
          <p
            onClick={() => {
              onTabChange("verticalTab");
            }}
            className={
              selectedAreaType?.value === "vertical" || selectedAreaType?.value === "verticalTab"
                ? "activeType"
                : "nonActiveType"
            }
          >
            {(selectedAreaType?.value === "vertical" || selectedAreaType?.value === "verticalTab") && 
              <span className="active-indicator"></span>
            }
            {t('mapPage:sidebar.tabs.verticalPVArea')}
          </p>
          <p
            onClick={() => onTabChange("detectionTab")}
            className={
              selectedAreaType?.value === "detection" || selectedAreaType?.value === "detectionTab"
                ? "activeType"
                : "nonActiveType"
            }
          >
            {(selectedAreaType?.value === "detection" || selectedAreaType?.value === "detectionTab") && 
              <span className="active-indicator"></span>
            }
            {t('mapPage:sidebar.tabs.detectionPoints')}
          </p>
        </div>
        <TiltedPvAreaPage projectName={projectInformation?.projectName} />
        <VerticalPvAreaPage projectName={projectInformation?.projectName} />
        <DetectionPvAreaPage />
        {(selectedAreaType?.value === undefined ||
          selectedAreaType?.value === "exclude" ||
          selectedAreaType?.value === "ruler") && (
          <div className="detectionNothingToShow" style={{ height: "70vh" }}>
            <div>
              <Image src={images.GoToPvArea} alt="addTiltedPVarea" loading="lazy" />
              <strong>{t('mapPage:sidebar.info.title')}</strong>
              <small>
                {t('mapPage:sidebar.info.description')}
              </small>
            </div>
          </div>
        )}
      </div>
      <div>
        <CalculateGlare />
      </div>
    </section>
  );
};

export default MapPageSidebar;